import queryString from 'query-string';
// @ts-ignore
import addURLToGlobal from '../../../../forkedLib/URL';

addURLToGlobal();

export default (link = '', replaceKey: string, plusQuery: { [k: string]: any; }) => {
  try {
    if (replaceKey && link.startsWith('sailorc://keeta.com/machproalert') && link.includes(replaceKey)) {
      const urlObj = queryString.parseUrl(link, { parseFragmentIdentifier: true });// parseFragmentIdentifier一定要有,否则会丢失哈希路由
      const queryDataString = urlObj.query[replaceKey] as string;
      let queryDataObject = {};
      if (typeof queryDataString === 'string' && queryDataString?.length > 0) {
        const decodedData = decodeURIComponent(queryDataString);
        queryDataObject = JSON.parse(decodedData);
      }

      // 重新赋值 data 部分
      const handleData = JSON.stringify({ ...queryDataObject, ...plusQuery });

      return queryString.stringifyUrl({ url: urlObj.url, query: { ...urlObj.query, ...{ [replaceKey]: handleData } } }, { sort: false });
    }
    return link;
  } catch (error) {
    // 内部报错时,不能影响正常连接跳转
    console.log(error);
    return link;
  }
};
